/**
 * product-tabs-defer.js — Issue #67
 *
 * The product-tabs section renders every tab panel in the DOM. To keep the
 * browser from prefetching images that belong to non-active panels, the
 * section rewrites those images' `src`/`srcset` to `data-src`/`data-srcset`
 * (see sections/product-tabs.liquid). This script promotes the real URLs back
 * onto the images the first time their panel is activated, so a panel's images
 * are only fetched once the shopper opens that tab.
 *
 * Activation is signalled by the `tabChange` CustomEvent that TabsComponent
 * dispatches (bubbles to document) with `detail.selectedTab` = the panel.
 * width/height/sizes attributes are untouched, so there is no layout shift.
 */
(function () {
  'use strict';

  function promotePanel(panel) {
    if (!panel || panel.dataset.deferredImages === 'loaded') return;

    var images = panel.querySelectorAll('img[data-src], img[data-srcset]');
    for (var i = 0; i < images.length; i++) {
      var img = images[i];
      // srcset first so the browser resolves the responsive candidate, not the
      // fallback src, once both are present.
      if (img.dataset.srcset) {
        img.setAttribute('srcset', img.dataset.srcset);
        delete img.dataset.srcset;
      }
      if (img.dataset.src) {
        img.setAttribute('src', img.dataset.src);
        delete img.dataset.src;
      }
    }

    panel.dataset.deferredImages = 'loaded';
  }

  document.addEventListener('tabChange', function (event) {
    var panel = event.detail && event.detail.selectedTab;
    if (!panel || !panel.closest) return;
    // Scope strictly to product-tabs panels flagged as deferred.
    if (!panel.matches('[data-deferred-images]')) return;
    promotePanel(panel);
  });
})();
